import { logger, StorageKeys, webSessionStorage } from 'obt-common';

const LOGOUT_QUERY_PARAM_KEY = 'logout';

export const injectLogoutQueryParam = (url: string) => {
  // Take the logout flag from the session storage and inject it into the URL as a query param
  // It was added to the session storage when the user clicked the logout button manually
  // Ref: ST-78535, ST-78019
  try {
    const userLogoutInitiated = webSessionStorage.getItem(StorageKeys.USER_LOGOUT_INITIATED);

    if (!userLogoutInitiated) {
      return url;
    }

    const urlWithLogoutQueryParam = new URL(url);
    urlWithLogoutQueryParam.searchParams.set(LOGOUT_QUERY_PARAM_KEY, 'true');
    webSessionStorage.removeItem(StorageKeys.USER_LOGOUT_INITIATED);
    return urlWithLogoutQueryParam.toString();
  } catch (err) {
    logger.error(
      new Error('Error injecting logout query param.', {
        cause: {
          message: err.message,
          code: err.code,
        },
      }),
    );
    return url;
  }
};
